module.exports = __webpack_public_path__ + "static/media/PairTilesAdvanced.5a5ede78.jpg";